import { css } from "@emotion/react"
import { above, below } from "@mkt/cp/src/styles/Breakpoints"
import { container, getDuration } from "@mkt/cp/src/styles/Functions"
import { animeShow } from "@mkt/ui/styles/Keyframes"
import { colorsCP } from "@mkt/cp/src/styles/Tokens"

export const hero = css`
  background-color: ${colorsCP["gray-0"]};
`

export const heroContainer = (type, isLoans) => {

  const home = css`
    padding-top: 80px;
    padding-bottom: 56px;

    ${below["m"]} {
      padding-top: 32px;
      padding-bottom: 32px;
    }
  `

  const loansPadding = css`
    padding-block: 0;

    ${above["m"]} {
      align-items: flex-end;
    }
  `

  const loansMedium = `align-items: flex-end;`

  return css`
    ${container};
    gap: 24px;
    display: flex;
    flex-direction: column;
    ${type === "home" && !isLoans && home}

    ${above["m"]} {
      gap: 60px;
      align-items: center;
      flex-direction: row;
      justify-content: space-between;
      ${isLoans && loansMedium}
    }

    ${isLoans && loansPadding}
  `
}

export const heroInfo = (type, isLoans) => {

  const list = css`
    padding-block: 32px;
  `

  const loans = css`
    padding-top: 32px;
    padding-bottom: 24px;

    ${above["m"]} {
      gap: 16px;
    }

    ${below["m"]} {
      text-align: center;
    }
  `

  return css`
    gap: 16px;
    display: flex;
    flex-direction: column;
    ${type === "list" && list}
    ${isLoans && loans}

    ${above["m"]} {
      gap: 24px;
      ${isLoans && loans}
    }
  `
}

export const heroTitle = (type, isLoans) => {

  const home = css`
    ${above["m"]} {
      font-size: 56px;
      line-height: 1.4;
      max-width: 705px;
      color: ${colorsCP["neutral-70"]};
    }
  `

  const loans = css`
    ${above["m"]} {
      font-size: 32px;
      line-height: 1.4;
      max-width: 690px;
      color: ${colorsCP["neutral-70"]};
    }
  `

  return css`
    opacity: 0;
    animation: ${animeShow} ${getDuration(1)} 0.2s ease forwards;
    ${type === "home" && home}
    ${isLoans && loans}
  `
}

export const heroSubtitle = css`
  opacity: 0;
  color: ${colorsCP["neutral-50"]};
  animation: ${animeShow} ${getDuration(1)} 0.3s ease forwards;
`

export const heroImageContainer = (type, isLoans) => {

  const list = css`
    ${below["m"]} {
      display: none;
    }
  `

  const loans = css`
    max-width: 340px;

    ${below["m"]} {
      display: none;
    }
  `

  return css`
    max-width: 544px;
    ${type === "list" && list}
    ${isLoans && loans}
    ${below["m"]} {
      margin: 0 auto;
    }
  `
}

export const heroImage = css`
  display: block;
  max-width: 100%;
  height: auto;
`
